
import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { WebSearchData } from '@/types/webSearch';
import WebSearchDetails from './WebSearchDetails';
import WebSearchContent from './WebSearchContent';
import SourcesList from './SourcesList';
import ErrorBoundary from '../ErrorBoundary';
import DataQualityModal from './DataQualityModal';
import { Button } from '@/components/ui/button';
import { LayoutList, FileText } from 'lucide-react';

interface WebSearchDataViewProps {
  searchData: WebSearchData;
  leadName?: string;
  keyContacts?: any[];
  editable?: boolean;
  onSaveSummary?: (markdown: string) => void;
  leadAddress?: string;
  leadPhone?: string;
  leadEmail?: string;
  leadWebsite?: string;
}

const WebSearchDataView: React.FC<WebSearchDataViewProps> = ({ searchData, leadName, keyContacts, editable, onSaveSummary, leadAddress, leadPhone, leadEmail, leadWebsite }) => {
  const [view, setView] = useState<'summary' | 'structured'>('summary');

  return (
    <Tabs defaultValue="websearch">
      <TabsList className="grid grid-cols-2">
        <TabsTrigger value="websearch">Web Search</TabsTrigger>
        <TabsTrigger value="sources">Sources</TabsTrigger>
      </TabsList>

      <TabsContent value="websearch" className="mt-4">
        <div className="flex justify-end mb-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setView(v => v === 'summary' ? 'structured' : 'summary')}
            className="text-xs gap-1.5 h-7"
          >
            {view === 'summary' ? (
              <><LayoutList className="h-3.5 w-3.5" /> Structured View</>
            ) : (
              <><FileText className="h-3.5 w-3.5" /> Summary View</>
            )}
          </Button>
        </div>
        <ErrorBoundary fallback={
          <div className="p-4 text-center text-muted-foreground">
            Unable to display details. Please try refreshing the data.
          </div>
        }>
          {view === 'summary' ? (
            <WebSearchContent searchData={searchData} keyContacts={keyContacts} editable={editable} onSave={onSaveSummary} />
          ) : (
            <WebSearchDetails searchData={searchData} leadName={leadName} keyContacts={keyContacts} leadAddress={leadAddress} leadPhone={leadPhone} leadEmail={leadEmail} leadWebsite={leadWebsite} />
          )}
        </ErrorBoundary>
      </TabsContent>

      <TabsContent value="sources" className="mt-4">
        <SourcesList sources={searchData?.sources} />
      </TabsContent>
    </Tabs>
  );
};

export default WebSearchDataView;
